import moment from "moment";

export const NOTIFICAION_REMINDERS_SUPPORTED_PARENT_TYPES = ["Task", "Note", "Discussion", "CalendarEvent"];

export const REMINDERS_SUPPORTED_PARENT_TYPES = ["Task", "Note", "Discussion", "CalendarEvent"];

export const DEFAULT_TIME = "07:00";
export const RELATED_FIELD_BY_PARENT_TYPE = {
  Task: "due_on",
  Note: null,
  Discussion: null,
  CalendarEvent: "starts_on",
};

export const RELATIVE_REMINDERS_SUPPORTED_PARENT_TYPES = ["Task", "CalendarEvent"];

const MAX_RELATIVE_VALUES = {
  day: 30,
  hour: 23,
  minute: 55,
};

export const resolveRelativeValues = (relatedDate, unit = "day", modifier = 1) => {
  let diff = MAX_RELATIVE_VALUES[unit];
  let offset = 1;
  let step = 1;

  if (modifier < 0) {
    let now = moment();
    if (unit === "day") {
      now = moment().startOf(unit);
    }
    diff = relatedDate.diff(now, unit);

    if (diff > MAX_RELATIVE_VALUES[unit]) {
      diff = MAX_RELATIVE_VALUES[unit];
    }
    if (unit === "minute") {
      offset = 0;
      step = 5;
      diff = (diff - (diff % 5)) / 5;
      diff++;
    }
  }

  return [...Array(diff)].map((_, index) => ({ id: (index + offset) * step, name: `${(index + offset) * step}` }));
};
